import { render } from "./LeftColumn.vue?vue&type=template&id=ba2bf4f6"
import script from "./LeftColumn.vue?vue&type=script&lang=js"
export * from "./LeftColumn.vue?vue&type=script&lang=js"

import exportComponent from "/home/robin/encyon/w/group/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__